import useFetcher from 'app/_utils/data/useFetcher';

import useSWR from 'swr';

type CopilotDisabledResponse = {
  disabled: boolean;
};

type CopilotConsentResponse = {
  items: Array<{
    id: string;
    accepted: boolean;
    initialized: boolean;
  }>;
};

export const useCopilotWidget = (leaderFQDN: string) => {
  const { fetcher } = useFetcher();

  const copilotWidgetEnabledFetcher = async (): Promise<boolean> => {
    const [isDisabledPromise, consentPromise] = await Promise.all([
      fetcher<CopilotDisabledResponse>(
        `https://${leaderFQDN}/api/v1/ai/settings/disabled`,
      ),
      fetcher<CopilotConsentResponse>(
        `https://${leaderFQDN}/api/v1/ai/consent`,
      ),
    ]);

    if (isDisabledPromise.disabled) {
      return false;
    }

    const hasAcceptedConsent = consentPromise.items.some((item) => item.accepted);

    return hasAcceptedConsent;
  };

  return useSWR<boolean>(
    leaderFQDN ? `copilot-widget-status-${leaderFQDN}` : null,
    copilotWidgetEnabledFetcher,
  );
};
